import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_GIFT_CARD,
  DELETE_GIFT_CARD,
  GET_ALL_GIFT_CARDS,
  GET_ALL_GIFT_CARDS_USAGE,
  GET_GIFT_CARD_DETAILS,
  GET_GIFT_CARD_LIST,
  GET_PREMIUM_GIFT_CARD_LIST,
  GET_GIFT_CARD_LIST_BY_CARD_TYPE,
  GET_GIFT_CARDS_USAGE_DETAILS,
  UPDATE_GIFT_CARD,
  UPDATE_GIFT_CARD_STATUS,
} from "helpers/url_helper"

export const getAllGiftsCards = createAsyncThunk(
  GET_ALL_GIFT_CARDS,
  async payload => {
    const response = await post(GET_ALL_GIFT_CARDS, payload)
    return response
  }
)

export const getGiftsCardList = createAsyncThunk(
  GET_GIFT_CARD_LIST,
  async () => {
    const response = await get(GET_GIFT_CARD_LIST)
    return response
  }
)

export const getPremiumGiftCardList = createAsyncThunk(
  GET_PREMIUM_GIFT_CARD_LIST,
  async () => {
    const response = await get(GET_PREMIUM_GIFT_CARD_LIST)
    return response
  }
)

export const getGiftsCardListByCardType = createAsyncThunk(
  GET_GIFT_CARD_LIST_BY_CARD_TYPE,
  async (payload) => {
    const response = await post(GET_GIFT_CARD_LIST_BY_CARD_TYPE,payload)
    return response
  }
)

export const addGiftCard = createAsyncThunk(ADD_GIFT_CARD, async payload => {
  const response = await formDataPost(ADD_GIFT_CARD, payload)
  return response
})

export const getGiftCardDetails = createAsyncThunk(
  GET_GIFT_CARD_DETAILS,
  async id => {
    const response = await get(`${GET_GIFT_CARD_DETAILS}/${id}`)
    return response
  }
)

export const updateGiftCard = createAsyncThunk(
  UPDATE_GIFT_CARD,
  async payload => {
    const response = await formDataPut(UPDATE_GIFT_CARD, payload)
    return response
  }
)

export const updateGiftCardStatus = createAsyncThunk(
  UPDATE_GIFT_CARD_STATUS,
  async payload => {
    const response = await patch(UPDATE_GIFT_CARD_STATUS, payload)
    return response
  }
)

export const deleteGiftCard = createAsyncThunk(
  DELETE_GIFT_CARD,
  async payload => {
    const response = await del(DELETE_GIFT_CARD, payload)
    return response
  }
)

export const getAllGiftCardsUsage = createAsyncThunk(
  GET_ALL_GIFT_CARDS_USAGE,
  async payload => {
    const response = await post(GET_ALL_GIFT_CARDS_USAGE, payload)
    return response
  }
)


export const getGiftCardUsageDetails = createAsyncThunk(
  GET_GIFT_CARDS_USAGE_DETAILS,
  async id => {
    const response = await get(`${GET_GIFT_CARDS_USAGE_DETAILS}/${id}`)
    return response
  }
)